import {
  buildNavigatorViewModelFromLive,
  type NavigatorResource,
  type NavigatorResultsViewModel,
  type MatchedSpecialtyApi,
} from '@/shared/components/navigator-results';

export type CareSeekerSuggestedResource = {
  id: string;
  title: string;
  seoUrl: string;
  category?: string;
  type?: string;
};

export type CareSeekerResultsInput = {
  careStageLabel: string;
  summaryBullets: string[];
  categories: MatchedSpecialtyApi[];
  resources: CareSeekerSuggestedResource[];
};

const mapResource = (resource: CareSeekerSuggestedResource): NavigatorResource => ({
  id: resource.id,
  title: resource.title,
  href: `/resource-hub-detail/${resource.seoUrl}`,
  type: resource.type ?? resource.category ?? null,
});

/**
 * Normalize the live find-providers matches + suggested resources into the
 * shared NavigatorResults view-model. Delegates category/provider mapping to
 * the shared builder (also used by the FP results page) and supplies the
 * care-seeker's suggested resources as care-stage resources.
 */
export const buildCareSeekerResultsViewModel = ({
  careStageLabel,
  summaryBullets,
  categories,
  resources,
}: CareSeekerResultsInput): NavigatorResultsViewModel =>
  buildNavigatorViewModelFromLive({
    planTitle: careStageLabel || 'Your Care Guide',
    careStageLabel: careStageLabel || 'Your Care Guide',
    summaryBullets,
    categories,
    careStageResources: resources.map(mapResource),
  });
